export default "__VITE_ASSET__D3aut01A__"